const config = {
    title: 'Scratch Connect',
    appUrl: '/',
    assets: {
        warningTitleLogoImage: {
            ref: '/assets/age_verification_logo.png',
            alt: 'Must be 18+ to play logo',
        },
        circleExclamation: {
            ref: '/assets/circle-exclamation.png',
            alt: 'exclamation logo',
        },
    },
    cssOverride: 'css encoded',
};

export default config;
